import React from 'react';
import UsersInformation from '../Classes/UsersInformation';
import BasicInformation from './BasicInformation';
import SectionCollapse from '../../../../../section/SectionCollapse';

const SurveyInfo = ({ detail = {} }) => {
  return (
    <>
      <div className='py-2' />
      <SectionCollapse title='Basic Information'>
        <BasicInformation detail={detail} />
      </SectionCollapse>
      <UsersInformation type='Users' items={detail?.users} />
    </>
  );
};

export default SurveyInfo;
